module.exports = __webpack_public_path__ + "img/bg_topDiv.36aa3a86.jpg";